module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Pencil-3cf793760d2f128c93f6a2cc47fcd5e7.svg";